module.exports = __webpack_public_path__ + "static/media/1.f4992269.jpg";